// export const API_URL = 'https://admin.grsf.in';
export const API_URL =  process.env.REACT_APP_API_URL;  //'https://admin.grsf.in';
export const PORTAL_URL = process.env.REACT_APP_PORTAL_URL;  // 'https://portal.grsf.in';
export const BASE_URL = process.env.REACT_APP_BASE_URL;  // 'http://localhost:3000';

export const endPoints = {
    faq:`${API_URL}/grsfAPI/getFaqs`,
    event:`${API_URL}/grsfAPI/getEvents`,
    news:`${API_URL}/grsfAPI/getNewsMedia`,
    updated:`${API_URL}/grsfAPI/getImpUpdates`,
    resource:`${API_URL}/grsfAPI/getResources`,
    gallery:`${API_URL}/grsfAPI/getNewsMediaImageGallery`,
    entry:`${API_URL}/grsfAPI/saveContactEntry`,
    getTypeOfStakeholderList:`${API_URL}/grsfAPI/getTypeOfStakeholderList`,
    visitorLog:`${API_URL}/api/Visitor/log`,
    visitorCount:`${API_URL}/api/Visitor/count`

}

